import { render, staticRenderFns } from "./CardPersonalData.vue?vue&type=template&id=b0d6243c&scoped=true"
import script from "./CardPersonalData.vue?vue&type=script&lang=js"
export * from "./CardPersonalData.vue?vue&type=script&lang=js"
import style0 from "./CardPersonalData.vue?vue&type=style&index=0&id=b0d6243c&lang=scss&scoped=true"
import style1 from "./CardPersonalData.vue?vue&type=style&index=1&id=b0d6243c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d6243c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0d6243c')) {
      api.createRecord('b0d6243c', component.options)
    } else {
      api.reload('b0d6243c', component.options)
    }
    module.hot.accept("./CardPersonalData.vue?vue&type=template&id=b0d6243c&scoped=true", function () {
      api.rerender('b0d6243c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LivenessHiveDetail/components/CardPersonalData.vue"
export default component.exports